<script setup>
import { computed } from 'vue';
import NavItem from '../NavItem/index.vue';
import { useTranslation } from '@/utils/locales/messages';
import { useLanguageStore } from '@/shared/stores/languageStore';

const props = defineProps({ item: Object, level: Number });

const languageStore = useLanguageStore();
const { createSyncT } = useTranslation();
const t = createSyncT(languageStore.currentLanguage);

// 언어 변경 시 자동으로 업데이트되도록 computed로 감싸기
const menuTitle = computed(() => {
  // titleKey가 있으면 우선 사용
  if (props.item.titleKey) {
    const translated = t(props.item.titleKey);
    // 번역 키가 그대로 반환된 경우 (번역을 찾지 못한 경우) 원본 title 사용
    if (translated === props.item.titleKey) {
      return props.item.title;
    }
    return translated || props.item.title;
  }
  // titleKey가 없으면 기존 방식 사용 (NavItem과 동일: 번역 미해결 시 원본 title 폴백)
  const translationKey = 'menu.' + props.item.title;
  const translated = t(translationKey);
  if (translated === translationKey || translated.startsWith('menu.')) {
    return props.item.title;
  }
  return translated || props.item.title;
});
</script>

<template>
    <!-- ---------------------------------------------- -->
    <!---Item Childern -->
    <!-- ---------------------------------------------- -->
    <v-list-group no-action>
        <!-- ---------------------------------------------- -->
        <!---Dropdown  -->
        <!-- ---------------------------------------------- -->
        <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" :value="item.title" rounded="pill" class="mb-1">
                <!---Icon  -->
                <template v-slot:prepend>
                    <Icon :icon="'solar:' + item.icon" height="18" width="18" class="dot" :class="'text-' + item.BgColor" :level="level" />
                </template>
                <!---Title  -->
                <v-list-item-title class="mr-auto">{{ menuTitle }}</v-list-item-title>
                <!---If Caption-->
                <v-list-item-subtitle v-if="item.subCaption" class="text-caption mt-n1 hide-menu">
                    {{ item.subCaption }}
                </v-list-item-subtitle>
            </v-list-item>
        </template>
        <!-- ---------------------------------------------- -->
        <!---Sub Item-->
        <!-- ---------------------------------------------- -->
        <template v-for="(subitem, i) in item.children" :key="i" v-if="item.children">
            <NavCollapse :item="subitem" v-if="subitem.children" :level="level + 1" />
            <NavItem :item="subitem" :level="level + 1" v-else></NavItem>
        </template>
    </v-list-group>

    <!-- ---------------------------------------------- -->
    <!---End Item Sub Header -->
    <!-- ---------------------------------------------- -->
</template>
